import cn from 'classnames';
import { ComponentProps, HTMLAttributes, useState } from 'react';
import { UiButton } from '@@/ui/components/ui-button';
import { numberWithSpaces } from '@lib/number-formatting';
import { Card } from '@ui/card';

import styles from './index.module.sass';

export function MixingSummaryAndCalculateCard(
  props: IMixingSummaryAndCalculateCardProps,
) {
  const { className, summaryPrice = 0, disabled, onCalculate, ...rest } = props;
  const rootClass = cn(styles.root, className);
  const [isCalculating, setIsCalculating] = useState(false);

  const onCalculateHandler = async () => {
    setIsCalculating(true);
    await onCalculate(summaryPrice);
    setIsCalculating(false);
  };

  return (
    <Card className={rootClass} {...rest}>
      <div className={styles.label}>Совокупная стоимость выбранных объемов</div>

      <div>
        <b>{numberWithSpaces(summaryPrice)} ₽</b>
      </div>

      <UiButton
        label="Рассчитать"
        disabled={disabled}
        loading={isCalculating}
        onClick={onCalculateHandler}
      />
    </Card>
  );
}

export interface IMixingSummaryAndCalculateCardProps
  extends Omit<ComponentProps<typeof Card>, 'children'> {
  summaryPrice: number;
  disabled: boolean;
  onCalculate: (price: number) => void | Promise<void>;
}
